
const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export const buildSalarySlipBreakdown = (payrollDetails) => {
  if (!payrollDetails) return null;

  const details = Array.isArray(payrollDetails.PayrollDetails)
    ? payrollDetails.PayrollDetails
    : [];

  const earnings = [];
  const deductions = [];

  details.filter((item) => {
    const active = item.HPD_IS_ACTIVE;

    return (
      active === undefined ||
      active === null ||
      active === "" ||
      active === true ||
      active === "True" ||
      active === "1" ||
      active === 1
    );
  })
  .forEach((item) => {
      const amount = round2(item.HPD_AMOUNT);

      if (!amount) return;

      const type = String(item.HPC_COMPONENT_TYPE || "").trim().toUpperCase();

      const label = item.HPD_DESCRIPTION || item.HPC_COMPONENT_NAME || "Payroll Component";

      if (type === "E") {
        earnings.push({
          label,
          amount,
        });
      } else if (type === "D") {
        deductions.push({
          label,
          amount,
        })
      }
  });

  const totalEarnings = round2(payrollDetails.HPH_TOTAL_EARNINGS);
  const totalDeductions = round2(payrollDetails.HPH_TOTAL_DEDUCTIONS);
  const netSalary = round2(payrollDetails.HPH_NET_SALARY);

  return {
    earnings,
    deductions,
    totalEarnings,
    totalDeductions,
    netSalary,
  }
}
